import { Track } from "../types";
import { HoverablePoint } from "./hoverable-point";

interface TrackPointProps {
  track: Track;
  confidence: number;
  shouldSkipPoint?: (index: number) => boolean;
  setSelected: (value: number) => void;
}

export function TrackPoint({
  track,
  confidence,
  shouldSkipPoint,
  setSelected,
}: TrackPointProps) {
  const poseConf = track.pose_conf || [];

  return track.pose_x.map((position, i) => {
    if (shouldSkipPoint && shouldSkipPoint(i)) {
      return null;
    }

    const hasEnoughConfidence =
      (poseConf && poseConf[i] > confidence) || poseConf.length === 0;

    if (hasEnoughConfidence) {
      return (
        <HoverablePoint
          key={i}
          index={i}
          position={[position, track.pose_z[i], -track.pose_y[i]]}
          onHover={setSelected}
          onUnhover={setSelected}
        />
      );
    } else {
      return null;
    }
  });
}
